<template>
  <div class="box_booktags">
    <div class="nav_bookmarks">
      <router-link to="/books" title="点击进入我的书籍页面" class="nav_grey">已阅读书籍</router-link>
      <span class="nav_hover">我的标注</span>
    </div>
    <div class="book_name" v-if="book_info">{{book_info.book_name}}({{book_info.volume_name}})
      <div class="tagdelete" v-show="!isdelete" @click="changedelete(1)"><span class="isdelete"></span>删除</div>
      <div class="tagdelete" v-show="isdelete" @click="changedelete(2)"><span class="iscancel"></span>取消</div>
    </div>
    <div
      class="time_line infinite-list"
      v-if="mytagsArr"
      ref="scrollList"
      v-infinite-scroll="getBookmarks"
      infinite-scroll-disabled="istagsall"
      infinite-scroll-distance="10"
      infinite-scroll-immediate="false"
    >
      <div
        :class="[index%2==0?'right':'left','list','infinite-list-item']"
        v-for="(item,index) in mytagsArr"
        :key="index"
      >
        <!-- {{item.content}} -->
        <img v-show="!tagdeleteArr[index]&&isdelete" class="deletetag" @click="changetag(item,index,1)" src="../../assets/tag/Check box_icon_nor@2x.png" />
        <img v-show="tagdeleteArr[index]&&isdelete" class="deletetag" @click="changetag(item,index,2)" src="../../assets/tag/Check box_icon_pre@2x.png" />
        <span class="tags_circle">
          <viewer>
          <img :src="item.url" alt />
          </viewer>
          <!-- <span @click="open_img(item)">查看原图</span> -->
        </span>
        <span class="tags_text">
          <span class="tags_page" @click="marksgo(item.img_id)">{{item.add_time}}</span>
          <span class="centent" @click="marksgo(item.img_id)">{{item.content}}</span>
        </span>
      </div>
    </div>
    <div class="img_open" v-show="openimg">
      <img :src="openimg_img" ondragstart="return false;" class="openimg_img" />
      <div class="closeimg" @click="openimg = !openimg"></div>
    </div>
    <div v-if="istagsall" class="no_more">没有更多了</div>
      <!-- <div class="bigbox" v-show="show" ref="myBig"> -->
        <!-- <div v-show="bigShow"></div> -->
      <!-- </div> -->
    <!-- <div v-else class="more_info">
            <div v-if="isLoading">
                <img src="../../assets/public/ancientBooks/loading.gif" alt="加载">
            </div>
    </div>-->
    <div class="export" v-show="!isdelete" @click="exporttag">导出</div>
    <div class="export" v-show="isdelete" @click="dialogVisible=true">删除</div>
    <div class="dialog" v-show="dialogVisible">
      <div class="dialog_center">
        <p class="dialogtitle">同时会把社区同步的标<br>
          注一起删除哦~</p>
        <div class="dialogconfirm">
          <p class="dialogfalse" @click="changedelete(2)">现在取消</p>
          <p class="dialogtrue" @click="deletetag">确认删除</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apiURL from '../../util/api'
import {addstamp} from '../../util/stamp';
export default {
  data() {
    return {
      tags_current_page: 1,
      per_page: 10,
      mytagsArr: [],
      book_info: null,
      istagsall: false,
      isLoading: false,
      isKaiGuan: true,
      volumeid: null,
      tags_total_pages: null,
      openimg: false,
      openimg_img: "",
      isdelete:false,
      tagdeleteArr:[],
      dialogVisible:false,
      show:false,
      bigShow:false,
      book_total_count:0
    };
  },
  created() {
    this.userid = parseInt(this.$store.state.user_id);
    this.volumeid = this.$route.query.volume_id;
    // this.volumeid = 203;
    const hashLocation = this.$route.path;
    //   const newLocation = hashLocation.split("#/")[1];
    const url = "https://www.kanguji.com" + hashLocation;
    this.$matomo.setCustomUrl(url); //覆盖页面报告的url，可以自定义页面url，加上本页面路由
    //   this.$matomo.trackEvent(shopCode,hashLocation);//事件
    // this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称
  },
  mounted() {
    this.getBookmarks();
    // if (this.$route.path == "/bookMarks") {
    //   window.addEventListener("scroll", this.menu);
    // } else {
    //   window.addEventListener("scroll", "");
    // }
  },
  methods: {
    changedelete(num){
      if(num == 2){
        this.dialogVisible=false
      }
      this.isdelete=!this.isdelete
      if(this.isdelete){
        for(var i=0;i<this.tagdeleteArr.length;i++){
          this.tagdeleteArr[i] = false
        }
      }
    },
    changetag(item,index,num){
      // console.log(num)
      if (num == 1) {
        this.$set(this.tagdeleteArr, index, true);
      } else {
        this.$set(this.tagdeleteArr, index, false);
      }
      // console.log(this.tagdeleteArr[index])
    },
    deletetag(){
      var that = this
      var tagArr = []
      for(var i=0;i<this.tagdeleteArr.length;i++){
        if(this.tagdeleteArr[i]){
          var tagid = this.mytagsArr[i].tag_id
          tagArr.push(tagid)
        }
      }
      // console.log(tagArr)
      var params = {
        user_id:this.userid,
        type:'tag',
        tag_ids:tagArr
      }
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      this.$axios.delete('tag',{params})
      .then(function(res) {
        // console.log(res)
        if(res.data.status_code == 200){
          that.isdelete = false
          that.tags_current_page = 1
          that.dialogVisible = !that.dialogVisible
          that.getBookmarks()
        }
      })
    },
    getBookmarks() {
      var that = this;
      var params = {
        user_id: this.userid,
        volume_id: this.volumeid,
        page: this.tags_current_page,
        page_size: this.per_page
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      that.$axios.get("tags", { params }).then(function(res) {
        // console.log(res);
        that.mytagsArr = res.data.data.book_tags;
        // console.log(that.mytagsArr);
        that.book_total_count = res.data.data.book_total_count
        that.mytagsArr = res.data.data.book_tags;
        that.tags_total_pages = res.data.data.total_pages;
        that.tags_current_page = res.data.data.current_page;
        if (res.data.status_code == 200) {
          that.isLoading = false;
          // this.isKaiGuan = true
          if (that.tags_current_page == that.tags_total_pages) {
            that.istagsall = true;
            // this.isKaiGuan = false
          }
          if (that.tags_current_page == 1) {
            that.mytagsArr = res.data.data.book_tags;
            that.tagdeleteArr = []
            if(that.mytagsArr.length == 0){
              that.$router.go(-1)
            }
          } else {
            that.mytagsArr = that.mytagsArr.concat(res.data.data.book_tags);
          }
          for(var i=0;i<res.data.data.book_tags;i++){
            that.tagdeleteArr.push(false)
          }
          that.book_info = res.data.data.book_info;
        }
      });
    },
    marksgo(imd) {
      let pictureUrl = this.$router.resolve({
        path: "/picture",
        query: {
          volume_id: this.volumeid,
          imd: imd,
          ct: this.book_total_count
        }
      });
      window.open(pictureUrl.href, "_blank");
    },
    open_img(item) {
      this.openimg = !this.openimg;
      this.openimg_img = item.url;
    },
    exporttag() {
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "正在准备中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
      }, 4000);
      // let baseURL = 'http://proxy.jiankanghao.net:50070/api/v1/'
      // let baseURL = "https://api.kanguji.com/api/v1/";
      let baseURL = apiURL
      let pictureUrl =
        baseURL +
        "tag/export?user_id=" +
        this.userid +
        "&volume_id=" +
        this.volumeid;
      window.location.href = pictureUrl;
      }
  },
  watch: {
    openimg() {
      if (this.openimg) {
        $("body").css({
          overflow: "hidden"
        });
      } else {
        $('body').removeAttr('style')
      }
    },
  }
};
</script>
<style lang="scss" scoped="" type="text/css">
.box_booktags {
  width: 1300px;
  min-height: 100%;
  margin: 30px auto 0;
  padding-bottom: 45px;
  background: #fff;
  // position: relative;
  // position: relative;
  // background-color:#fff;
  .nav_bookmarks,
  .book_name{
    width: 1230px;
    margin: 0 auto;
  }
  .nav_grey {
    color: #666;
    font-size: 14px;
    font-family: PingFangSC-Regular, sans-serif;
    display: inline-block;
  }
  .nav_hover {
    font-size: 14px;
    font-family: PingFangSC-Regular, sans-serif;
    background: url("../../assets/public/companyNews/next_icon@2x.png")
      no-repeat left center;
    background-size: 16px;
    padding-left: 20px;
    line-height: 20px;
    color: #333;
  }
  .book_name {
    font-size: 24px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #333;
    text-align: center;
    line-height: 1;
    margin-top: 10px;
    position: relative;
    .tagdelete{
      height: 18px;
      font-family: AlibabaPuHuiTiL;
      position: absolute;
      right: 0px;
      bottom: 0px;
      font-size: 16px;
      font-weight: normal;
      color: #AD896B;
      cursor: pointer;
      z-index: 9;
      span{
        width: 18px;
        height: 18px;
        display: inline-block;
        margin-right: 2px;
        vertical-align: sub;
      }
      .isdelete{
        background: url("../../assets/tag/delete_icon_nor@2x.png") no-repeat center center;
        background-size: cover;
      }
      .iscancel{
        background: url("../../assets/tag/esc_icon_nor@2x.png") no-repeat center center;
        background-size: cover;
      }
      &:hover{
        color: #9D7A5C;
        .isdelete{
          background: url("../../assets/tag/delete_icon_pre@2x.png") no-repeat center center;
          background-size: cover;
        }
        .iscancel{
          background: url("../../assets/tag/esc_icon_pre@2x.png") no-repeat center center;
          background-size: cover;
        }
      }
    }
  }
  .time_line {
    // padding: 2em 0;
    position: relative;
    // margin-top:95px;
    margin-bottom: 50px;
    padding-top: 60px;
    margin-top: 15px;
    overflow-y: auto;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      height: 100%;
      width: 2px;
      background: #dcdcdc;
      margin-left: -1px;
    }
    .list {
      width: 655px;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 98px;
      // margin-top:50px;
      &:last-child {
        margin-bottom: 35px;
      }
      &::before {
        display: block;
        content: "";
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: #e5e5e5;
        position: absolute;
      }
      &::after {
        display: block;
        content: "";
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #d55d3a;
        position: absolute;
      }
      .img_circle {
        display: inline-block;
        width: 86px;
        height: 86px;
        border: 7px solid #eeeeee;
        border-radius: 50%;
        overflow: hidden;
        vertical-align: top;
        cursor: pointer;
        img {
          margin-left: -40px;
          margin-top: -30px;
        }
      }
      .deletetag{
        width: 18px;
        height: 18px;
        display: inline-block;
        margin-top: 40px;
        cursor: pointer;
      }
      .tags_circle {
        display: inline-block;
        width: 86px;
        height: 86px;
        line-height: 86px;
        border: 7px solid #eeeeee;
        position: relative;
        // border-radius: 50%;
        overflow: hidden;
        vertical-align: top;
        cursor: pointer;
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        span {
          display: none;
          // display: block;
          width: 100%;
          height: 100%;
          line-height: 86px;
          text-align: center;
          color: #fff;
          background: rgba(47, 81, 92, 0.7);
          position: absolute;
          top: 0;
          left: 0;
          transition: 1s;
        }
        &:hover span {
          display: block;
        }
      }
      .tags_text {
        vertical-align: top;
        // margin-left: 30px;
        margin-top: -10px;
        // margin-right: 30px;
        position: relative;
        width: 410px;
        color: #fff;
        .tags_page,
        .content {
          display: block;
        }
        .tags_page {
          color: #d55d3a;
          font-size: 30px;
          cursor: pointer;
          font-weight: 500;
          font-family: DINAlternate-Bold;
          margin-right: 5px;
        }
        .centent {
          width: 410px;
          display: block;
          font-size: 16px;
          font-family: AlibabaPuHuiTiL;
          color: #333;
          line-height: 26px;
          cursor: pointer;
          margin-top: 6px;
        }
      }
      .text {
        vertical-align: top;
        margin-left: 20px;
        margin-top: -22px;
        position: relative;
        .mark_page,
        .time {
          display: block;
        }
        .mark_page {
          font-size: 20px;
          cursor: pointer;
          color: #fff;
          font-family: AlibabaPuHuiTiB;
          font-weight: bold;
          .font_74 {
            color: #d55d3a;
            font-weight: 500;
            font-size: 56px;
            font-family: DINAlternate-Bold;
            margin-right: 5px;
          }
        }
        .time {
          display: block;
          font-size: 30px;
          font-family: DINAlternate-Bold;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .right {
      float: right;
      padding-left: 44px;
      &::before {
        top: 40px;
        left: -3px;
      }
      &::after {
        top: 43px;
        left: 0px;
      }
      .deletetag,
      .tags_circle,
      .img_circle,
      .text,
      .tags_text {
        float: left;
      }
      .tags_text{
        margin-left: 30px;
      }
      .deletetag{
        margin-right: 20px;
      }
    }
    .left {
      padding-right: 44px;
      float: left;
      text-align: right;
      &::before {
        top: 40px;
        right: -3px;
      }
      &::after {
        top: 43px;
        right: 0px;
      }
      .deletetag,
      .img_circle,
      .text,
      .tags_circle,
      .tags_text {
        float: right;
      }
      .tags_text{
        margin-right: 30px;
      }
      .deletetag{
        margin-left: 20px;
      }
    }

    &::after {
      content: "";
      display: table;
      clear: both;
    }
  }
}
.img_open {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  // top: calc(50% - 300px);
  // left: calc(50% - 500px);
  /* border: 1px solid red; */
  background: #333;
  border-radius: 6px;
  .openimg_img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    margin: 0 auto;
    // margin-top: 50px;
  }
  .closeimg {
    cursor: pointer;
    // border: 1px solid red;
    width: 38px;
    height: 38px;
    position: absolute;
    top: 85px;
    right: 300px;
    z-index: 999;
    background: url(../../assets/picture/mark_icon_nor@2x.png) no-repeat;
    background-size: 100% 100%;
    &:hover {
      background: url(../../assets/picture/mark_icon_pre@2x.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}
.export {
  width: 150px;
  height: 44px;
  margin: 0 auto;
  cursor: pointer;
  position: sticky;
  left: calc(50% - 75px);
  bottom: 44px;
  line-height: 44px;
  color: #fff;
  font-size: 18px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  border-radius: 4px;
  text-align: center;
  background: linear-gradient(0deg, #ff7c5a, #e6522b);
}
.dialog {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  .dialog_center {
    width: 400px;
    height: 210px;
    border-radius: 6px;
    background: #fff;
    position: absolute;
    top: calc(50% - 105px);
    left: calc(50% - 200px);
    // box-shadow: 0 0 0 999px rgba(0, 0, 0, 0.3);
    .dialogtitle {
      font-size: 24px;
      color: #333;
      margin-top: 37px;
      text-align: center;
      font-weight: bold;
    }
    .dialogconfirm {
      margin-top: 35px;
      display: flex;
      justify-content: space-around;
      p {
        line-height: 40px;
        text-align: center;
        border-radius: 6px;
        font-size: 20px;
        cursor: pointer;
        font-family: AlibabaPuHuiTiR;
      }
      .dialogfalse {
        width: 143px;
        height: 38px;
        border: 1px solid rgba(220, 220, 220, 1);
        // box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
        transition: transform 0.15s;
        // text-shadow: 1px 2px 1px rgba(77, 9, 36, 0.6);
        &:active {
          transform: translate(0, 1px) !important;
          transition: transform 0.15s ease;
          animation: input-shadow 0.15s ease;
          // box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);
        }
      }
      .dialogtrue {
        width: 145px;
        height: 40px;
        background: linear-gradient(
          45deg,
          rgba(255, 124, 90, 1),
          rgba(230, 82, 43, 1)
        );
        color: #fff;
        // box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
        transition: transform 0.15s;
        // text-shadow: 1px 2px 1px rgba(77, 9, 36, 0.6);
        &:active {
          transform: translate(0, 1px) !important;
          transition: transform 0.15s ease;
          animation: input-shadow 0.15s ease;
          // box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
}
  .bigbox{
    position: fixed;
    z-index: 999;
  }
</style>
<style>
.el-loading-spinner i{
  color: #E6522B;
}
.el-loading-spinner .el-loading-text{
  color: #E6522B;
}
</style>


// WEBPACK FOOTER //
// src/components/page/bookTags_standby.vue